//user action
export const SHOW_ONBOARD = "SHOW_ONBOARD";
export const SET_USER_LOGIN_DATA = "SET_USER_LOGIN_DATA";
export const REMOVE_USER_LOGIN_DATA = "REMOVE_USER_LOGIN_DATA";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_ADDRESSES = "SET_USER_ADDRESSES";
export const ADD_USER_ADDRESS = "ADD_USER_ADDRESS";
export const UPDATE_USER_ADDRESS = "UPDATE_USER_ADDRESS";
export const REMOVE_USER_ADDRESS = "REMOVE_USER_ADDRESS";

//items actions
export const SET_ITEM_TYPES = "SET_ITEM_TYPES";
export const SET_ITEMS = "SET_ITEMS";

//fav actions
export const SET_FAV_ITEMS = "SET_FAV_ITEMS";
export const ADD_FAV_ITEM = "ADD_FAV_ITEM";
export const REMOVE_FAV_ITEM = "REMOVE_FAV_ITEM";

//cart actions
export const SET_CART_ITEMS = "SET_CART_ITEMS";
export const ADD_CART_ITEM = "ADD_CART_ITEM";
export const UPDATE_CART_ITEM = "UPDATE_CART_ITEM";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";

//order actions
export const SET_ORDERS = "SET_ORDERS";
export const ADD_ORDER = "ADD_ORDER";
export const SET_CHECKOUT_ORDER_INFO = "SET_CHECKOUT_ORDER_INFO";
export const SET_CURRENT_ORDER = "SET_CURRENT_ORDER";
export const UPDATE_ORDER = "UPDATE_ORDER";

//filter actions
export const SET_FILTER_OPTIONS = "SET_FILTER_OPTIONS";
export const SET_USER_FILTER = "SET_USER_FILTER";
